import logo from './logo.svg';
import './App.css';
import { useState ,useReducer } from 'react';
import { type } from '@testing-library/user-event/dist/type';
import Resultreducer from "./Reducer/reducer"//ربط USEREDUCER
function App() {
  const[firstnumberinput,setfirstnumberinput]=useState(null)
  const[Secoundnumberinput,setsecoundnumberinput]=useState(null)
  const[result,setresult]=useState(null)
  const[result2,dipatch]=useReducer(Resultreducer,[]);

//  useReducer function


  function handelsumclick() {
    // const result= (Number(firstnumberinput)+Number(Secoundnumberinput))
    // setresult(result);
    dipatch( {type:'sum',dypaid:{
       Firstnamber:firstnumberinput,
       Secoundnumber:Secoundnumberinput
    }});
  }
  function handelsubclick() {
    // const result= (Number(firstnumberinput)-Number(Secoundnumberinput))
    // setresult(result);
    dipatch({type:'sup',dypaid:{
       Firstnamber:firstnumberinput,
       Secoundnumber:Secoundnumberinput
    }});
  }
  function handelmultclick() {
    // const result= (Number(firstnumberinput)*Number(Secoundnumberinput))
    // setresult(result);
    dipatch({type:'mult',
      dypaid:{
      Firstnamber:firstnumberinput,
      Secoundnumber:Secoundnumberinput
    }});
  }
  function handelduvclick() {
    // const result= (Number(firstnumberinput)/Number(Secoundnumberinput))
    // setresult(result);
    dipatch({type:"duv",
      dypaid:{
       Firstnamber:firstnumberinput,
      Secoundnumber:Secoundnumberinput
    }})
  }
  return (
  <div
  style={{
    backgroundColor:"gold",
    height:"100vh",
    alignItems:"center",
    display:"flex",
    justifyContent:"center",
    flexDirection:"column"//يعمل صددر جديد في كل شي داخله

  }}
  >
   <h1>FirstNumbr</h1>
   
   <input 
   value={firstnumberinput}
   onChange={(e)=>setfirstnumberinput(e.target.value)}
   />
   
   <h1>SecoundNumbr</h1>
   
   <input 
   value={Secoundnumberinput}
   onChange={(e)=>setsecoundnumberinput(e.target.value)}
   />
   
   <button onClick={handelsumclick}>sum</button>
   <button onClick={handelsubclick}>sup</button>
   <button onClick={handelmultclick}>mult</button>
   <button onClick={handelduvclick}>duv</button>
   {/* <h2>{result}</h2> */}
   <h2>{result2}</h2>
  </div>
  );
}
export default App;
